<template>
  <FormMenus :p_item_menus="item_menus" 
  :p_item_roles="item_roles" :p_item_menuroles="idmenurol" 
  @saveParent="save"
    @saverolParent="saverol" @savemenurolParent="savemenurol" 
    :p_fields_errors="fields_errors"
    :p_sucursal="current_sucursal" @isClear="clear" />

  <v-card class="my-3">
    <v-text-field v-model="buscar_registros" append-inner-icon="mdi-file-search-outline" clearable
      label="Buscar Registros" color="cyan-darken-1">
    </v-text-field>
    <v-data-table :headers="headers" :items="datos" :search="buscar_registros"
      :items-per-page-options="items_per_page_options" class="mt-10" :hover="true" :fixed-header="true" :height="500"
      :show-current-page="true" :loading="change" page-text="{0}-{1} de {2}">

      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.id }} </td>
          <td>{{ item.nombre }} </td>
          <td>{{ item.icono }}</td>
          <td>{{ item.posicion }}</td>
          <td>{{ item.estado }}</td>
          <td>{{ item.submenu }}</td>
          <td>{{ item.enlace }}</td>
          <td>
            <div style="min-width: 150px;">
              <v-btn @click="editForm(item)" class="ma-1" color="cyan-darken-1" icon="mdi-pencil" variant="outlined" />
              <v-btn @click="deleteItem(item)" color="red" class="ma-1" icon="mdi-delete" variant="outlined" />
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>

  <v-dialog v-model="dialog_delete" persistent transition="dialog-bottom-transition" max-width="500px">
    <v-card class="pa-5">
      <v-card-text class="text-center">
        <v-icon icon="mdi mdi-trash-can-outline" size="100" color="red"
          class="animate__animated animate__infinite animate__bounce"></v-icon>

      </v-card-text>
      <p class="text-subtitle-1 text-center">
        ¿Esta seguro(a) de eliminar este registro?
      </p>

      <div class="d-flex justify-center">
        <v-btn color="red" variant="outlined" @click="closeDialogDelete" class="ma-1">
          <v-icon icon="mdi-cancel"></v-icon>&nbsp;Cancelar
        </v-btn>
        <v-btn color="cyan-darken-1" variant="outlined" class="ma-1" @click="confirmDeleteItem">
          <v-icon icon="mdi-check-bold"></v-icon>&nbsp;Aceptar
        </v-btn>
      </div>

    </v-card>
  </v-dialog>

  <v-dialog v-model="dialog_import" persistent transition="dialog-bottom-transition" scrollable width="600px"
    max-height="600px">
    <DialogImportCliente :p_current_sucursal="current_sucursal" @isCloseDialogImportData="closeDialogImportData"
      @isInitData="initData" />
  </v-dialog>
</template>
  
<script>
import { defineComponent } from 'vue';

//import Cliente from '@/http/services/Cliente';
import Menus from '@/http/services/Menus';
import MenuRoles from '@/http/services/Menus';
import Roles from '@/http/services/Roles';

import FormMenus from '@/components/menus/FormMenus.vue';
import useToastify from '@/composables/useToastify';
import Sucursal from '@/http/services/Sucursal';
import DialogImportCliente from '@/components/cliente/DialogImportCliente.vue';
export default defineComponent({
  components: {

    FormMenus,
    DialogImportCliente,
  },

  data() {
    const obj_menus = new Menus();

    const change = null;
    const datos = [];
    const item_menus = {};
    const item_roles = {};
    const index_item = -1;
    const buscar_registros = "";
    const fields_errors = null;
    const dialog_delete = false;
    const dialog_import = false;
    const list_sucursal = [];
    const current_sucursal = "";
    const headers = [
      { title: '#', key: 'id', },
      { title: 'Nombre', key: 'nombre', },
      { title: 'Icono', key: 'icono', },
      { title: 'Posicion', key: 'posicion', },
      { title: 'Estado', key: 'estado', },
      { title: 'Submenu', key: 'submenu', },
      { title: 'Enlace', key: 'enlace', },
      { title: 'Acciones', key: 'actions', },
    ];

    const items_per_page_options = [
      { value: 10, title: '10' },
      { value: 25, title: '25' },
      { value: 50, title: '50' },
      { value: 100, title: '100' },
    ];
    const idmenurol = { menu_id: null, role_id: null};
    return {
      obj_menus,
      headers,
      change,
      datos,
      item_menus,
      item_roles,
      index_item,
      items_per_page_options,
      buscar_registros,
      fields_errors,
      dialog_delete,
      list_sucursal,
      current_sucursal,
      dialog_import,
      idmenurol,
    }
  },
  mounted() {
    this.registros();
  },
  methods: {

    registros() {
      this.change_table = "cyan";
      setTimeout(async () => {
        const response = await this.obj_menus.getmenus();
        console.log("Esta es la respuesta", response);
        this.datos = response.records;
        console.log("Esta es la respuesta de menus", this.datos);
        if (response.status) {
          this.datos = response.records;
        } else {
          console.error("Respuesta inválida o sin registros.");
        }
        this.change_table = null;
      }, 1000);
    },

    async listSucursal() {
      const sucursal = new Sucursal();
      const response = await sucursal.index();
      if (response.status) {
        const sucursal_all = response.records;
        this.list_sucursal = sucursal_all.map(item => item.nombres);
        this.current_sucursal = this.list_sucursal[0];
      } else {
        useToastify('danger', response.message);
      }
    },

    newForm() {
      //const menu = new Menu();
      //this.item_menus = menu.getAttributes();
    },//newForm

    editForm(item) {
      this.clear();
      this.index_item = this.datos.indexOf(item);
      this.item_menus = Object.assign({}, item);
    },

    deleteItem(item) {
      this.index_item = this.datos.indexOf(item);
      this.item_menus = Object.assign({}, item);
      this.dialog_delete = true;
    },//deleteItem

    async confirmDeleteItem() {
      const menu = new Menus();
      menu.setAttributes(this.item_menus);
      const response = await menu.destroy();
      if (response.status) {
        useToastify('success', response.message)
        //eliminamos el dato del array
        this.datos.splice(this.index_item, 1);
      } else {
        useToastify('danger', response.message)
      }
      this.closeDialogDelete();
    },

    async save() {
      const obj_menus = new Menus();
      if (this.item_menus.id > 0) {
        Object.assign(this.datos[this.index_array], this.item_menus);
        const response = await obj_menus.modificarmenus(this.item_menus);
        if (response.status) {
          this.snackbar_registers_enabled = true;
          this.snackbar_color = "cyan-darken-3";
          this.snackbar_registers_message = response.message;
        } else {
          this.snackbar_registers_enabled = true;
          this.snackbar_color = "red";
          if (response.validate_errors) {
            this.errors_validate = response.message_errors;
            this.snackbar_registers_message = response.message;
          } else {
            this.snackbar_registers_message = "Error interno en el servidor";
          }
        }
      } else {
        const response = await obj_menus.registrarmenu(this.item_menus);
        if (response.status) {
          this.snackbar_color = "cyan-darken-3";
          this.snackbar_registers_enabled = true;
          this.snackbar_registers_message = response.message;
        } else {
          this.snackbar_color = "red";
          this.snackbar_registers_enabled = true;
        }
      }
    },
    async saverol() {
      const obj_roles = new Roles();
      if (this.item_roles.id > 0) {
        Object.assign(this.datos[this.index_array], this.item_roles);
        const response = await obj_roles.modificarroles(this.item_roles);
        if (response.status) {
          this.snackbar_registers_enabled = true;
          this.snackbar_color = "cyan-darken-3";
          this.snackbar_registers_message = response.message;
          //this.closeDialogForm();
        } else {
          this.snackbar_registers_enabled = true;
          this.snackbar_color = "red";
          if (response.validate_errors) {
            this.errors_validate = response.message_errors;
            this.snackbar_registers_message = response.message;
          } else {
            this.snackbar_registers_message = "Error interno en el servidor";
          }
        }
      } else {
        const response = await obj_roles.registrarrole(this.item_roles);
        if (response.status) {
          this.snackbar_color = "cyan-darken-3";
          this.snackbar_registers_enabled = true;
          this.snackbar_registers_message = response.message;
          //this.closeDialogForm();
        } else {
          this.snackbar_color = "red";
          this.snackbar_registers_enabled = true;
        }
      }
    },
    async savemenurol() {
      //console.log("Esta es la respuesta de la Tabla", this.idmenurol);
      const keys = Object.keys(this.idmenurol);

      // Crear un array usando las claves y los valores correspondientes del objeto Proxy
      const arrayResult = keys.map(key => ({ [key]: this.idmenurol[key] }));

      // Resultado
      console.log(arrayResult);
      const extractNumbers = (str) => {
  const match = str.match(/\d+/); // Expresión regular para encontrar números
  return match ? match[0] : null;
};

// Aplicar la función a cada elemento del array
const extractedNumbersArray = arrayResult.map((obj) => {
  const keys = Object.keys(obj);
  const newObj = {};
  keys.forEach((key) => {
    newObj[key] = extractNumbers(obj[key]);
  });
  return newObj;
});

// Resultado final
console.log("Este es el id extraido",extractedNumbersArray);
    
      /* const obj_menuroles = new MenuRoles(this.item_menuroles);
      const menuId = typeof this.item_menuroles.menu_id === 'string' ? this.item_menuroles.menu_id.split(' ')[0] : '';
      console.log('menu_id:', this.item_menuroles.menu_id);
      this.item_menuroles.menu_id = menuId;
      console.log("Esta es la respuesta extraido", menuId);

      // Extraer el ID de la pais y asignarlo a agencia_id
      const roleId = typeof this.item_menuroles.role_id === 'string' ? this.item_menuroles.role_id.split(' ')[0] : '';
      this.item_menuroles.role_id = roleId;
      console.log("Esta es la respuesta extraido", roleId);
       */
/*       const idmenurolCopy = { ...this.idmenurol };
console.log("este es mi idmenurol", idmenurolCopy);
      this.$emit('savemenurolParent', idmenurolCopy);

      const obj_menuroles = new MenuRoles(this.idmenurol);
      console.log("este es mi idmenurol obj_menuroles", obj_menuroles);
      this.idmenurol = this.idmenurol || {};
      const menuId = this.idmenurol && typeof this.idmenurol.menu_id === 'string' ? this.idmenurol.menu_id.split(' ')[0] : '';
      console.log("Esta es la respuesta extraido del menui", menuId);
      this.idmenurol.menu_id = menuId;

      // Extraer el ID del rol y asignarlo a role_id
      const roleId = typeof this.idmenurol.role_id === 'string' ? this.idmenurol.role_id.split(' ')[0] : '';
      this.idmenurol.role_id = roleId;
      console.log("Esta es la respuesta extraido del rol", roleId);
      if (this.idmenurol.id > 0) {
        Object.assign(this.datos[this.index_array], this.data);
        const response = await obj_menuroles.modificarmenuroles(this.data);
        if (response && response.status) {
          this.snackbar_registers_enabled = true;
          this.snackbar_color = "cyan-darken-3";
          this.snackbar_registers_message = response.message;

        } else {
          this.snackbar_registers_enabled = true;
          this.snackbar_color = "red";
          if (response.validate_errors) {
            this.errors_validate = response.message_errors;
            this.snackbar_registers_message = response.message;
          } else {
            this.snackbar_registers_message = "Error interno en el servidor";
          }
        }
      } else {
        const response = await obj_menuroles.registrarmenuroles(this.idmenurol);
        console.log("Esta es la respuesta", response);
        if (response.status) {
          this.snackbar_color = "cyan-darken-3";
          this.snackbar_registers_enabled = true;
          this.snackbar_registers_message = response.message;
          //this.idmenurol.id = response.record.id;
          this.datos.push(this.idmenurol);

          this.registros();
        } else {
          this.snackbar_color = "red";
          this.snackbar_registers_enabled = true;

          this.registros();
          if (response.validate_errors) {
            this.snackbar_registers_message = response.message;
            this.errors_validate = response.message_errors;
          } else {
            this.snackbar_registers_message = "Error interno en el servidor";
          }
        }
      } */

    },


    closeDialogDelete() {
      this.dialog_delete = false;
      this.clear();
    },//closedialogDelete

    clear() {
      this.fields_errors = {};
      this.item_menus = {};
      this.index_item = -1;
      this.newForm();
    },//clear

    async openDialogImportData() {
      this.dialog_import = true;
    },

    closeDialogImportData() {
      this.dialog_import = false;
    },


  },//metodos

  async created() {
    await this.listSucursal();
    this.newForm();
  }

});

</script>


